/* eslint-disable complexity */
import {
  AMERITAS_DENTAL,
  AMERITAS_VISION,
  DENTAL,
  LATITUDE,
  PRIMARY_DNV_ADD_ONS,
  SUPPLEMENTAL_BENEFIT,
  VISION
} from 'core/constants/products'
import initPeriodController from 'pug/mixins/editableCoveragePeriod/fullInputs'
import loadSTMBTMPlans from 'pug/mixins/editableCoveragePeriod/loadSTMBTMPlans' // cspell:disable-line
import getAdditionalInfo from './components/products/getAdditionalInfo'
import getBenefitsTooltips from 'utils/pivot/plan/getBenefitsTooltips'
import getApplicant from 'core/renders/planDetailsCard/getApplicant'
import freeLookPeriod from 'utils/pivot/plan/freeLookPeriod'
import renderView from './components/products/renderView'
import individualState from 'core/DOM/individualState'
import toastNotification from 'pug/toastNotification'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import setAttribute from 'utils/DOM/setAttribute'
import isRXPlan from 'utils/pivot/plan/isRXPlan'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import { SIMILAR_PLANS } from 'messages'
import forEach from 'utils/DOM/forEach'
import store from 'utils/store/withMiddleware'
import getPremium from 'core/controllerPlans/getPremium'
import moneyFormat from 'utils/format/money'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import getPlanDetailTooltip from 'utils/pivot/plan/getPlanDetailTooltip'
import isQuantumPlan from 'utils/pivot/plan/isQuantumPlan'
import { updateSessionContext } from 'core/services/updateApplicantContext'
import initSmartly from 'core/initPage/absmartly'
import isPlanPPO from 'utils/pivot/plan/isPlanPPO'
import querySelectorAll from 'utils/DOM/querySelectorAll'
import setMichiganEpicPlanDisclaimer from 'utils/pivot/disclaimer/setMichiganEpicPlanDisclaimer'
import getCommissionDisclosureLink from 'sites/pivothealth.com/short-term-health-insurance/consumer/start-application/utils/getCommissionDisclosureLink'
import setPennsylvaniaEpicPlanSBC from 'utils/pivot/SBC/setPennsylvaniaEpicPlanSBC'
import renderAssistedNotice from 'core/DOM/renderAssistedNotice'
import registerSnowplowListeners from './registerSnowplowListeners'
import { prepareDataToTrack } from 'STM/consumer/start-application/prepareDataToTrack'
import is1200Plan from 'utils/pivot/plan/is1200Plan'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import isClicPlan from 'utils/pivot/plan/isClicPlan'
import isSureCarePlan from 'utils/pivot/plan/isSureCarePlan'
import initForumBanner from 'pug/mixins/forumBanner/controller'

const asMoney = moneyFormat

function initDOM(state) {
  const {
    hcStorage,
    planId,
    plans,
    carriers,
    brochures,
    plansByType,
    showAlternativeCoverage,
    filters,
    brochuresByProductType,
    dentalPlanId,
    latitudeId,
    visionPlanId,
    maxPolicies,
    planHasChanged
  } = state
  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })
  // window.hc.smartlySDK is used safely because initPage() was executed before
  const smartlySDK = initSmartly()

  if (smartlySDK) {
    smartlySDK.track('ph_display_start-application')
    smartlySDK.publish()
  }

  const plan = plans[planId]

  const commissionDisclosureLink = getCommissionDisclosureLink(planId)

  forEach('.link-commission-disclosure', node => {
    node.href = commissionDisclosureLink
  })

  toggleClass('.limitation-exclusions-footer', 'd-block', true)

  const stateAcronym = hcStorage.location.state_acronym

  const is1200 = is1200Plan(plan, stateAcronym)
  toggleClass('body', is1200 ? 'is1200' : 'is5100')

  setPennsylvaniaEpicPlanSBC(stateAcronym, plan)
  renderAssistedNotice(hcStorage.location)

  // Non insurance benefits
  individualState(stateAcronym)

  renderDentalVision(state)

  // Info section
  forEach('.js-plan-logo', node => {
    node.alt = carriers[plan.carrierId].name + ' | PivotHealth'
    node.src = carriers[plan.carrierId].logo
  })

  const renaissanceVisionId = plansByType[VISION]
  const renaissanceVisionPlan = renaissanceVisionId
    ? plans[renaissanceVisionId[0]]
    : false

  if (renaissanceVisionPlan) {
    const visionPremium = getPremium(renaissanceVisionPlan)
    const visionNode = getById('vision-checkbox')
    innerHTML('.js-vision-price', asMoney(visionPremium))

    // Check the box to include vision coverage by default if:
    // - the user has not selected a Latitude or dental plan or Ameritas vision plan (i.e. they haven't touched any add-ons)
    // - the user has selected a Renaissance vision plan (but not an Ameritas one)
    if (
      visionNode &&
      ((!latitudeId && !dentalPlanId && !visionPlanId) ||
        visionPlanId === renaissanceVisionPlan.planId)
    ) {
      visionNode.checked = true
    } else {
      visionNode.checked = false
    }
  }

  toggleClass('.plan-panel__actions', 'd-none', !plans[14])

  // members section
  const applicant = getApplicant(hcStorage)
  textContent('.js-members-applicant', `${applicant.gender}, ${applicant.age} years old `)

  const additionalMembers = hcStorage.members.length - 1
  if (additionalMembers > 0) {
    textContent(
      '.js-members-additional',
      `+${additionalMembers} dependent${additionalMembers > 1 ? 's' : ''}`
    )
    toggleClass('.js-members-additional', 'd-none')
  }

  // cigna plan
  toggleClass(document.body, 'cigna', plan.coreBenefits.networkProvider === 'cigna')

  const isEpic = isEpicPlan(plan)
  const isEpicPPO = isEpic && isPlanPPO(plan)
  const isQuantum = isQuantumPlan(plan)
  const isClic = isClicPlan(plan)
  const isSureCare = isSureCarePlan(plan)

  initForumBanner(hcStorage, isClic)

  const marketingMessage = isQuantum
    ? 'Includes Supplemental Accident'
    : isEpic
    ? 'Includes Free Telemedicine'
    : ''

  textContent('.js-marketing-msg', marketingMessage)

  toggleClass(document.body, 'nric', isEpic)

  if (stateAcronym === 'NE') {
    toggleClass(document.body, 'nric-ppo', isEpicPPO)

    if (isEpicPPO) {
      forEach(querySelectorAll('.disclaimer__NE'), node => {
        if (node.childElementCount > 2) {
          node.children[1].remove()
        }
      })
    }
  }
  setMichiganEpicPlanDisclaimer({ hcStorage, plansByType, plans, planId })

  toggleClass(document.body, 'clic', isClic)
  toggleClass(document.body, 'sure_care', isSureCare)

  const tooltips = getBenefitsTooltips()
  setAttribute('.tooltip-deductible', 'title', tooltips.deductible)
  setAttribute('.tooltip-coinsurance', 'title', tooltips.coinsurance)
  setAttribute('.tooltip-coverage', 'title', tooltips.coverage)
  setAttribute('.tooltip-moop', 'title', tooltips.moop)

  const planDetailTooltip = getPlanDetailTooltip(plan, isEpic)
  setAttribute('.plan-card__tooltip-info', 'title', planDetailTooltip)

  textContent('.free-look-period', freeLookPeriod(stateAcronym, plan.productId))

  // update brochure
  const brochureNode = document.querySelector('.js-brochure')
  brochureNode.href = brochures[plan.brochureId]
  // products section
  const supplemental = isEpic ? plansByType[SUPPLEMENTAL_BENEFIT] : []

  // Get additional information from user, to know if it has Dental
  // or Vision active.
  getAdditionalInfo(hcStorage)
    .then(({ hasDentalActive, hasVisionActive }) => {
      const hasDentalEnabled = hasDentalActive || hasVisionActive

      const addOns = PRIMARY_DNV_ADD_ONS.flatMap(
        productId => state.plansByType[productId]
      )

      renderView({
        addOns: addOns,
        hasDentalEnabled,
        latitude: plansByType[LATITUDE],
        supplemental,
        plans,
        hcStorage,
        brochures,
        period: filters.period
      })

      store.update({})
    })
    .then(() => {
      updateSessionContext(store.getState().hcStorage, null)
    })

  if (showAlternativeCoverage) {
    toastNotification(SIMILAR_PLANS)
  }

  const policies = maxPolicies ? maxPolicies : 1
  textContent('.js-max-policies', `${policies} ${policies > 1 ? 'policies' : 'policy'}`)
  toggleClass(document.body, 'epic', isEpic)
  toggleClass('#js-wrap-name', 'd-none', !isRXPlan(plan))

  const dentalBrochure = getById('dental-brochure')
  dentalBrochure?.setAttribute('href', brochuresByProductType[DENTAL])

  const latitudeBrochure = getById('latitude-brochure')
  latitudeBrochure?.setAttribute('href', brochuresByProductType[LATITUDE])

  const ameritasDentalBrochure = getById('ameritas-dental-brochure')
  ameritasDentalBrochure?.setAttribute('href', brochuresByProductType[AMERITAS_DENTAL])

  const ameritasVisionBrochure = getById('ameritas-vision-brochure')
  ameritasVisionBrochure?.setAttribute('href', brochuresByProductType[AMERITAS_VISION])

  toggleClass('.plan-switch__wrap', 'd-none', !planHasChanged)

  // Edit period
  initPeriodController(loadSTMBTMPlans, Object.keys(plan.durations), state, true) // cspell:disable-line
  prepareDataToTrack(planId, state)
  registerSnowplowListeners()
}

/**
 * Renders the Dental and Vision column.
 *
 * The plans are rendered in three sections: Renaissance, Ameritas Dental, and Ameritas Vision.
 * If the user has selected a Renaissance plan or no dental plan, then the Renaissance section is rendered first.
 * If the user has selected an Ameritas Dental plan, that section is rendered first instead.
 * If the user has selected an Ameritas Vision plan, then the Ameritas Vision section is rendered after the active
 * dental plan section (or first, if no dental is selected).
 */
function renderDentalVision(state: any): void {
  const dentalPlan = state.plans[state.dentalPlanId]
  const visionPlan = state.plans[state.visionPlanId]

  if (dentalPlan?.productId === DENTAL) {
    renderRenaissance(state)

    if (visionPlan?.productId === AMERITAS_VISION) {
      renderAmeritasVision(state)
      renderAmeritasDental(state)
    } else {
      renderAmeritasDental(state)
      renderAmeritasVision(state)
    }
  } else if (dentalPlan?.productId === AMERITAS_DENTAL) {
    renderAmeritasDental(state)
    renderAmeritasVision(state)
    renderRenaissance(state)
  } else if (visionPlan?.productId === AMERITAS_VISION) {
    renderAmeritasVision(state)
    renderAmeritasDental(state)
    renderRenaissance(state)
  } else {
    renderRenaissance(state)
    renderAmeritasDental(state)
    renderAmeritasVision(state)
  }
}

/** Renders Renaissance dental and vision add-ons */
function renderRenaissance(state: any): void {
  if (!state.plansByType[DENTAL]) return

  const template = Templater(getById('template-dental-section-renaissance').innerText)
  $('#dental-content').append(template())
}

/** Renders Ameritas dental add-ons */
function renderAmeritasDental(state: any): void {
  if (!state.plansByType[AMERITAS_DENTAL]) return

  const template = Templater(getById('template-dental-section-ameritas').innerText)
  $('#dental-content').append(
    template({
      stateAbbrev: state.hcStorage.location.state_acronym
    })
  )
}

/** Renders Ameritas vision add-ons */
function renderAmeritasVision(state: any): void {
  if (!state.plansByType[AMERITAS_VISION]) return

  const template = Templater(getById('template-vision-section-ameritas').innerText)
  $('#dental-content').append(
    template({
      stateAbbrev: state.hcStorage.location.state_acronym
    })
  )
}

export default initDOM
